export default "__VITE_ASSET__Cku1IuGo__"